import { CameraSlash } from '@app/components/various/Icons';
import { useTranslation } from 'react-i18next';

import styles from '../ScannerContent.module.scss';

export const NoSupport = () => {
  const { t } = useTranslation(['common']);

  return (
    <div className={styles.message}>
      <CameraSlash className="size-12 text-neutral-60" />
      <p>{t('common:scanning_not_supported')}</p>
    </div>
  );
};
